import React from 'react'
import './css/skills.css'
function Skills() {
  return (
    <div className='container'>
      <h1>skills</h1>
      
        <div className='card_skill'>html</div>
        <div className='card_skill'>css</div>
        <div className='card_skill'>js</div>
        <div className='card_skill'>node js</div>
        <div className='card_skill'>react js</div>
        <div className='card_skill'>angular js</div>
        <div className='card_skill'>php</div>
        <div className='card_skill'>c</div>
        <div className='card_skill'>java</div>
        <div className='card_skill'>mongodb</div>
     
    </div>
  )
}

export default Skills
